import { createReducer } from '@reduxjs/toolkit'

import {
  APRCalculatorField,
  resetAPRCalculator,
  setHighestPriceChange,
  setLowestPriceChange,
  setShowExpiredIncentives,
  setUseCustomRange,
} from './actions'

export interface StakingState {
  // APR Calculator state (positive values internally, display logic in component)
  readonly [APRCalculatorField.LOWEST_PRICE_CHANGE]: number
  readonly [APRCalculatorField.HIGHEST_PRICE_CHANGE]: number
  readonly useCustomRange: boolean
  // Incentives display options
  readonly showExpiredIncentives: boolean
}

const initialState: StakingState = {
  [APRCalculatorField.LOWEST_PRICE_CHANGE]: 10, // Default is 10 (shown as -10%)
  [APRCalculatorField.HIGHEST_PRICE_CHANGE]: 10, // Default is 10 (shown as 10%)
  useCustomRange: false, // Default is off
  showExpiredIncentives: false, // Default to hiding expired incentives
}

export default createReducer<StakingState>(initialState, (builder) =>
  builder
    .addCase(setLowestPriceChange, (state, { payload: { value } }) => {
      // Ensure the value is always positive in the state
      state[APRCalculatorField.LOWEST_PRICE_CHANGE] = Math.abs(value)
    })
    .addCase(setHighestPriceChange, (state, { payload: { value } }) => {
      state[APRCalculatorField.HIGHEST_PRICE_CHANGE] = value
    })
    .addCase(setUseCustomRange, (state, { payload: { enabled } }) => {
      state.useCustomRange = enabled
    })
    .addCase(setShowExpiredIncentives, (state, { payload: { show } }) => {
      state.showExpiredIncentives = show
    })
    .addCase(resetAPRCalculator, () => {
      return initialState
    })
)
